import { render } from "./suspendCardPopup.vue?vue&type=template&id=1f455182&scoped=true"
import script from "./suspendCardPopup.vue?vue&type=script&lang=js"
export * from "./suspendCardPopup.vue?vue&type=script&lang=js"

import "./suspendCardPopup.vue?vue&type=style&index=0&id=1f455182&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f455182"]])

export default __exports__